import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { riskSelector } from 'redux/reducers/riskReducer';
import { AccountForm } from 'routes/Risk/components/AccountForm';
import { CreditLimitsMatrix } from 'routes/Risk/components/CreditLimitsMatrix';
import { Matrix } from 'routes/Risk/components/Matrix';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface MatrixTabsProps {
  readonly readOnly: boolean;
}

export const MatrixTabs = ({ readOnly }: MatrixTabsProps) => {
  const risk = useSelector(riskSelector);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    event.preventDefault();
    event.stopPropagation();
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Order Limits" {...a11yProps(0)} />
          <Tab label="Credit Limits" {...a11yProps(1)} />
          <Tab label="Account" {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Matrix matrix={risk.matrix} readOnly={readOnly} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <CreditLimitsMatrix
          riskCreditLimitsMatrix={risk.riskCreditLimitsMatrix}
          readOnly={readOnly}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AccountForm readOnly={readOnly} />
      </CustomTabPanel>
    </Box>
  );
};
